import _ from 'lodash';
import {
  SCHEME_DOCUMENT_LOADING,
  SCHEME_DOCUMENT_UPDATE,
  SCHEME_DOCUMENTS_ERROR, SCHEME_DOCUMENTS_LOADING,
  SCHEME_DOCUMENTS_UPDATE, SCHEME_TYPE_DOCUMENTS
} from "../actions/schemesDocumentsActions";

const INITIAL_STATE = {
  schemeDocuments: [],
  schemeDocumentsPagination: null,
  schemeDocumentsLoading: false,
  schemeDocumentsError: null,
  schemeTypeDocuments: [],
  schemeDocumentLoading: false,
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case SCHEME_DOCUMENTS_UPDATE:
      return {
        ...state,
        schemeDocuments: _.mapKeys(action.payload.data, "id"),
        schemeDocumentsPagination: action.payload.pagination,
        schemeDocumentsError: action.payload.message,
      };
    case SCHEME_DOCUMENTS_ERROR:
      return {
        ...state,
        schemeDocumentsError: action.payload,
      };
    case SCHEME_DOCUMENTS_LOADING:
      return {
        ...state,
        schemeDocumentsLoading: action.payload,
      };
    case SCHEME_DOCUMENT_UPDATE:
      const scheme = action.payload.data;
      const schemeDocuments = {...state.schemeDocuments, [scheme.id]: scheme};
      return { ...state, schemeDocuments: schemeDocuments };
    case SCHEME_DOCUMENT_LOADING:
      return {
        ...state,
        schemeDocumentLoading: action.payload,
      };
    case SCHEME_TYPE_DOCUMENTS:
      return { ...state, schemeTypeDocuments: action.payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/documents/reducers/SchemeDocumentsReducer.js